module.exports = __webpack_public_path__ + "img/bg_yunduan_home.50673436.png";